import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import i18n from 'i18n';
import GuidePopup from 'components/Common/Popup/GuidePopup';
import Tip from 'components/Common/Template/Tip';
import * as popupActions from 'redux/ducks/common/popupDucks';

export const TabGnbMenu = () => {
  const dispatch = useDispatch();
  const isShowGuide = useSelector(state => state.popup.isShowGuide);

  return (
    <>
      <div className="content">
        <div className="tab img-area menu" />
        <div className="left-wrap">
          <div className="wrapper">
            <div className="large-title">
              <Trans i18nKey="BTY_W_T_ADD_MENU_T" />
            </div>
          </div>
          <div>
            <Trans i18nKey="BTY_W_T_ADD_MENU_INFO" />
          </div>
          <div className="large-text">
            <div
              className="link"
              onClick={() => {
                dispatch(popupActions.openGuide());
              }}
            >
              {i18n.t('BTY_W_T_LOOK_MENU_MORE')}
            </div>
          </div>
        </div>
      </div>
      <Tip subText={<Trans i18nKey="BTY_W_T_MENU_GUIDE" />} />

      {isShowGuide && (
        <GuidePopup title={i18n.t('BTY_W_T_LOOK_MENU')} contents={i18n.t('BTY_W_T_ADD_MANAGER')} imgName="img_gnb1" />
      )}
    </>
  );
};

export default TabGnbMenu;
